/**
 * Formats time in seconds to a human-readable string
 * @param seconds - Time in seconds
 * @returns Formatted time string (e.g., "2m 30s", "1h 15m", "45s")
 */
export function formatTimeRemaining(seconds: number): string {
  if (seconds <= 0) {
    return "0s";
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }

  if (remainingSeconds > 0 || parts.length === 0) {
    parts.push(`${remainingSeconds}s`);
  }

  return parts.join(" ");
}

/**
 * Formats time in seconds to a more detailed human-readable string
 * @param seconds - Time in seconds
 * @returns Formatted time string (e.g., "2 minutes 30 seconds", "1 hour 15 minutes", "45 seconds")
 */
export function formatTimeRemainingDetailed(seconds: number): string {
  if (seconds <= 0) {
    return "0s";
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }

  if (remainingSeconds > 0 || parts.length === 0) {
    parts.push(`${remainingSeconds}s`);
  }

  return parts.join(" ");
}
